(ns practitest.frontend.forms3.entity-form.traceability
  (:require
   [clojure.string :as str]
   [practitest.frontend.common-entities :refer [batch-navigate! grid-columns]]
   [practitest.frontend.common-entities.events :as common-events]
   [practitest.frontend.common-entities.link-entities-events :as link-events]
   [practitest.frontend.common-entities.metadata :refer [entities-metadata
                                                         get-entity-name]]
   [practitest.frontend.forms3.entity-form.utils :refer [get-modal-title]]
   [practitest.frontend.common-entities.utils :refer [entity-icon]]
   [practitest.frontend.common.dom :as dom]
   [practitest.frontend.common.format-utils :as fu]
   [practitest.frontend.common.i18n :refer [format-translation get-translation] :as i18n]
   [practitest.frontend.components.grid.sessionstorage :as grid-session-storage]
   [practitest.frontend.common.mixpanel :as mixpanel]
   [practitest.frontend.common.permissions :as permissions]
   [practitest.frontend.common.re-frame :refer [partial-dispatch partial-subscribe partial-dispatch-sync]]
   [practitest.frontend.common.tooltip :as common-tooltip]
   [practitest.frontend.components.grid.events :as grid.events]
   [practitest.frontend.components.grid.filters :as grid-filters]
   [practitest.frontend.components.grid.localstorage :as grid-storage]
   [practitest.frontend.components.grid.subs :as grid.subs]
   [practitest.frontend.components.icons :as icons]
   [practitest.frontend.components.notifications :as notifications]
   [practitest.frontend.components.tooltip :as tooltip]
   [practitest.frontend.components2.add-entities :as add-entities]
   [practitest.frontend.components2.buttons :as buttons]
   [practitest.frontend.components2.dropdown :as dropdown]
   [practitest.frontend.components2.grid :as grid2]
   [practitest.frontend.components2.pagination :as pagination]
   [practitest.frontend.components2.requirement-testing-status :as requirement-testing-status]
   [practitest.frontend.components2.run-status :as run-status]
   [practitest.frontend.forms3.testset.instances :refer [locked-execution-icon]]
   [practitest.frontend.forms3.entity-form.forms :as forms3]
   [practitest.frontend.forms3.entity-form.fields :as fields3]
   [practitest.frontend.forms3.entity-form.traceability-scope-utils :as scope-utils]
   [practitest.frontend.requirements.events :as requirements-events]
   [practitest.frontend.tests.events :as tests-events]
   [practitest.frontend.requirements.testing-coverage :as testing-coverage]
   [practitest.frontend.routing.backend-routes :as broutes]
   [practitest.frontend.routing.router :as router]
   [practitest.frontend.subs :as subs]
   [practitest.frontend.forms3.entity-form.traceability-linked-entity-columns :as traceability-linked-entity-columns]
   [re-frame.core :as re-frame]
   [clojure.set :refer [intersection]]
   [reagent.core :as reagent]))

(re-frame/reg-sub
  ::traceability
  (fn [db]
    (get-in db [:entity (:current-entity db) :traceability])))

(re-frame/reg-event-fx
  ::on-linked-entites-query-changed
  (fn [_ [_ grid-entity state-key grid-query]]
    (re-frame/dispatch [::common-events/fetch-entity-list grid-entity state-key grid-query])))

(def LINKED_ENTITIES_LIMIT 100)
(def LINKED_TESTS_FOR_REQUIREMENT_LIMIT 300)
(def LINKED_TESTSETS_FOR_REQUIREMENT_LIMIT 10)

(defn- get-linked-entity-limit [entity-type linked-entity-type]
  (cond
    (and (= entity-type :requirement) (= linked-entity-type :test))
    LINKED_TESTS_FOR_REQUIREMENT_LIMIT

    (and (= entity-type :test) (= linked-entity-type :requirement))
    LINKED_TESTS_FOR_REQUIREMENT_LIMIT

    (and (= entity-type :requirement) (= linked-entity-type :testset))
    LINKED_TESTSETS_FOR_REQUIREMENT_LIMIT

    :else
    LINKED_ENTITIES_LIMIT))

(defn- grid-options [{:keys [state-key
                             table-id-suffix
                             current-entity
                             linked-entity-type
                             linked-entities-key-plural
                             entity-id
                             entity-name]} disabled-row?]
  (let [entity-str (name current-entity)
        linked-entity-str (name linked-entity-type)
        translation-key-prefix (str
                                 (name current-entity)
                                 "."
                                 (name linked-entity-type))]
    {:dialog-table-id       (str (:id @(re-frame/subscribe [::subs/current-project]))
                                 "-" entity-str "-link-" table-id-suffix)
     :data                  (re-frame/subscribe [::grid.subs/data [current-entity state-key]])
     :columns               (re-frame/subscribe [::grid.subs/columns [current-entity state-key]])
     :selected-entities     (re-frame/subscribe [::grid.subs/selection [current-entity state-key]])
     :selected?             #(re-frame/subscribe [::grid.subs/selected? [current-entity state-key] %])
     :all-selected?         #(re-frame/subscribe [::grid.subs/all-selected? [current-entity state-key] %])
     :toggle-selection      (partial-dispatch [::grid.events/toggle-selection [current-entity state-key]])
     :toggle-selection-page (partial-dispatch [::grid.events/toggle-selection-page [current-entity state-key]])
     :current-page          (re-frame/subscribe [::grid.subs/entities-current-page current-entity state-key])
     :total-count           (re-frame/subscribe [::grid.subs/entities-total-count current-entity state-key])
     :full-data?            (re-frame/subscribe [::grid.subs/entities-full-data? current-entity state-key])
     :module (get-in entities-metadata [linked-entity-type :module])
     :title (get-modal-title
              (get-translation (str linked-entity-str ".add.plural")
                               (str "Add" " " linked-entity-str))
              (get-translation (str "to."(name current-entity))
                               (str " to " (get-entity-name current-entity :singular)))
              entity-id
              entity-name)
     :disabled-row? disabled-row?
     :disabled-row-tooltip (fn [row]
                        (let [linked-entities (get @(re-frame/subscribe [::traceability]) linked-entities-key-plural)
                              linked-ids (set (map #(:id %) linked-entities))
                              current-entity-id @(re-frame/subscribe [::subs/current-entity-id current-entity])
                              has-testset-scope? (and (= current-entity :test)
                                                      (= linked-entity-type :requirement)
                                                      (= (:testing_scope row) "TESTSETS"))
                              linked-entity-limit (get-linked-entity-limit current-entity linked-entity-type)]
                          (cond
                            (>= (count linked-entities) linked-entity-limit)
                            (format-translation (get-translation "entity.traceability.linked_entity_limit"
                                                                 "Note: The maximum number of linked entities allowed is %{limit}.")
                                                {:limit linked-entity-limit})
                            (contains? linked-ids (:id row))
                            (format-translation
                             (get-translation "entity.already-linked" "%{linked-entity} already linked to this %{entity}")
                             {:entity entity-str
                              :linked-entity linked-entity-str})
                            (= (:id row) current-entity-id)
                            (format-translation
                             (get-translation "entity.same-as-current" "Same %{entity} cannot be linked")
                             {:entity entity-str})
                            has-testset-scope?
                            (get-translation "requirement.traceability.testset-scope-disabled"
                                             "This requirement uses Test Set linkage. To link individual tests, change the linkage type from the requirement's traceability page."))))
     :disabled-select-all? #(some disabled-row? %)
     :disabled-select-all-tooltip (get-translation (str translation-key-prefix ".some-already-linked")
                                                   (str "Cannot select all "
                                                        linked-entity-str
                                                        " because some of the " linked-entity-str " already linked to this "
                                                        entity-str))
     :add-entities-button-label (get-translation (str linked-entity-str ".link.add-selected")
                                                 (str "Add selected %{n} " (get-in entities-metadata [linked-entity-type :linked-label])))}))

(defn- link-entities-dialog-options [{:keys [state-key link-event default-filter-name current-entity grid-entity]}]
  (let [query-event ::common-events/fetch-entity-list]
    {:show? (re-frame/subscribe [::grid.subs/show-link-entities-modal? current-entity state-key])
     :hide! #(re-frame/dispatch [::link-events/hide-link-entities-modal state-key])
     :show-views? (re-frame/subscribe [::grid.subs/link-entities-show-views? current-entity state-key])
     :filters (re-frame/subscribe [::grid.subs/link-entities-filters current-entity state-key default-filter-name])
     :current-filter-selected (re-frame/subscribe [::grid.subs/link-entities-current-filter-selected current-entity state-key])
     :set-current-filter (partial-dispatch [::common-events/set-current-filter grid-entity state-key
                                            ::common-events/fetch-entity-list])
     :set-current-folder (partial-dispatch [::common-events/set-current-folder grid-entity state-key
                                            ::common-events/fetch-entity-list-by-folder])
     :on-query-changed (partial-dispatch [::on-linked-entites-query-changed grid-entity state-key])
     :on-add-entities (partial-dispatch [link-event grid-entity state-key])
     :loading? (re-frame/subscribe [::subs/progress? query-event])}))

(defn- instance-link [url display_id parameters]
  [:a {:target "blank" :href url}
   (get-translation "requirement.coverage.instance_id" "Instance ID")
   " "
   display_id
   " "
   "{"
   (if (empty? parameters)
     (get-translation "requirement.coverage.no_parameters" "No parameters")
     (str/join ", " (map (fn [[k v]] (str (name k) ": " v)) parameters)))
   "}"])

(defn- instance-last-run [last-run]
  (when last-run
    (str
      (get-translation "requirement.coverage.last_run" "Last Run")
      " "
      (fu/formatted-local-date last-run))))

(defn- instance-row [idx {:keys [id display_id url parameters last_run run_status]}]
  ^{:key id}
  [:div.instance-row
   [:span.wrapper
    [:hr.vertical-line
     {:class (when (= idx 0) "first-instance")}]
    [:hr.horizontal-line]]
   [:span.name-with-link
    [instance-link url display_id parameters]]
   [:span
    [instance-last-run last_run]]
   [:span
    [run-status/run-status-component run_status]]])

(defn instances-view [instances]
  [:<>
   (for [[idx instance] (map-indexed vector instances)]
     [instance-row idx instance])])

(defn- item-status [item]
  (let [status (case (:type item)
                 "test" (:run_status item)
                 "requirement" (:status item)
                 (:status item))]
    (if status
      [:div {:style {:width  "136px"}} ; TODO use grid layout instead
       [:span.status-holder
        (case (:type item)
          "test" [run-status/run-status-component status]
          "requirement" [requirement-testing-status/requirement-status-component status]
          status)]]
      [:<>])))

(defn- new-test-dropdown [{:keys [entity-id entity-type new?] :as form-props} disabled?]
  (let [can-create-test? (and
                          (not new?)
                          (->
                           (get-in entities-metadata [:test :edit-permissions])
                           (permissions/has-permission?)))
        ai-enabled? @(re-frame/subscribe [::subs/generative-ai-consent?]) 
        class "add-test-dropdown hide-text"]
    
    [dropdown/dropdown-button
     {:text (get-translation "test.button.generate" "Generate")
      :tertiary? true
      :disabled? disabled?
      :class class
      :icon [icons/mux-smart-fox2]}
     {:placement "bottom-end"}

     [dropdown/dropdown-menu-item
      {:text (get-translation "test.button.generate-new" "Generate New Test")
       :icon [icons/mux-plus-circle]
       :disabled? (not can-create-test?)
       :tooltip (when new?
                  (get-translation "test.button.generate-steps-new-requirement-tooltip"
                                   "This action will only be available after the requirement is created"))
       :on-click (let [add-new-test-uri (broutes/get-url-view "qtest_designs#new"
                                                              {}
                                                              {"requirement_id" entity-id})]
                   (fn [e]
                     (mixpanel/track "Requirement - Create new Test")
                     (dom/navigate! add-new-test-uri)))}]
     [dropdown/dropdown-menu-item
      {:text (get-translation "test.button.generate-new-with-steps" "Generate New Test with Steps")
       :icon [icons/mux-smart-fox2]
       :disabled? (or (not ai-enabled?)
                      (not can-create-test?))
       :tooltip (cond
                  new?
                  (get-translation "test.button.generate-steps-new-requirement-tooltip"
                                   "This action will only be available after the requirement is created")

                  (not ai-enabled?)
                  (get-translation "test.smartfox.no-ai-consent-tooltip"
                                   "Generative AI consent is needed for this account")

                  :else
                  nil)
       :href (router/get-href (get-in entities-metadata [:test :routes :new])
                              {:project-id @(re-frame/subscribe [::subs/current-project-id])}
                              {:requirement_id entity-id
                               :generate_steps true}
                              {:tab "steps"})}]]))

(defn- traceability-item
  [{:keys [entity-type entity-id edit-permissions? new?]} metadata-key item type]
  [:div.card
   [:div.card-info
    [:div
     [:span.entity-type-icon [entity-icon metadata-key]]
     [:span.entity-type-text
      (str (get-entity-name metadata-key :singular-name) " #" (:display_id item) ":")]
     [:span.name-with-link
      [:a {:target "blank" :href
           (->
             (get-in entities-metadata [metadata-key :urls :edit])
             (broutes/get-url-view {:id (:id item)}))}
       (:name item)]]]
    [:div.d-flex.gap-12
     [item-status item]
     (when (and (not (= type :called_by_ctts))
                (not (and (= type :issues)
                          (= entity-type :test)))
                edit-permissions?)
       [:span.delete-button
        {:on-click (if new?
                     #(re-frame/dispatch [::link-events/stage-unlink-entity item])
                     #(re-frame/dispatch [::link-events/unlink-entity entity-type entity-id item]))}
        [icons/mux-trash]])]]
   (when (>= (count (:instances item)) 2)
     [instances-view (:instances item)])])

(defn- section-title
  [entity-type type count & [form-props]]
  (cond
    (= type :ancestor_info)
    (str (get-translation "test.traceability.ancestor-info" "Ancestor Info") " (" count ")")
    (= type :requirement_children)
    (str (get-translation "requirement.traceability.children" "Requirement Children") " (" count ")")
    (= type :run)
    (str (get-translation "testset.linked-runs" "Linked Runs") " (" count ")")
    (= type :instance)
    (str (get-translation "instance.linked-runs" "Linked Runs") " (" count ")")
    ;; Text specific for instance screen traceability - slightly different wording
    (and (= type :instances)
         (= entity-type :instance)
         (= (:form-id form-props) :instance-main))
    (str (get-translation "instance.other-instances" "Other instances of this test") " (" count ")")
    :else
    (let [entity-type (if (= :called_by_ctts type) type entity-type)
          label       (get-in entities-metadata [entity-type :linked-label])
          translated  (get-translation (str (name entity-type) ".linked")
                                       (str "Linked " label))
          project-setting @(re-frame/subscribe [::subs/current-project])
          enforce-test-traceability? (and (= entity-type :requirement)
                                          (= (:entity-type form-props) :test)
                                          (:enforce_test_traceability project-setting))
          title-text (str translated " (" count ")")]
      (if enforce-test-traceability?
        [:span.text-nowrap
         [:span title-text]
         [:span.mandatory "*"]]
        title-text))))

(defn compute-disabled-state
  [{:keys [has_permissions? parent_diff?]}]
  (let [is-cloning-enabled? @(re-frame/subscribe [::subs/test-cloning-update-enabled?])
        disabled-reason
        (cond
          (not has_permissions?)      :no-permission
          (not is-cloning-enabled?)   :cloning-disabled
          (not parent_diff?)          :no-diff)

        disabled-tooltip
        (case disabled-reason
          :no-permission
          (get-translation "test.tooltip.cloning-section.no-permissions"
                           "You do not have sufficient permissions to perform this update")

          :cloning-disabled
          (get-translation "test.tooltip.cloning-section.not-corporate"
                           "Updates have been made to the ancestor of this test.
                            Upgrade to our plan to update this test quickly.")

          nil)]

    {:disabled?        (some? disabled-reason)
     :disabled-tooltip disabled-tooltip}))

(defn called-by-tests-section-tooltip
  []
  [:span.traceability-section-tooltip
   [common-tooltip/info-circle-tooltip
    [:div.grid.gap-2
     [:div (get-translation "test.tooltip.tracaebility.called_to_test" "List of tests that call this test steps")]
     [:div {:dangerouslySetInnerHTML
            {:__html (format-translation
                       (get-translation "test.tooltip.tracaebility.for_more_info" "For more information, please visit our %{help_ctt_page_link}")
                       :help_ctt_page_link (str "<a target=_blank href=" broutes/help-menu-help-ctt-url ">"
                                                (get-translation "generic.label.help_page" "help page")
                                                "</a>"))}}]]]])

(defn test-cloning-section-tooltip
  []
  [:span
   {:on-click (fn [e] (dom/stop-propagation e))}
   [common-tooltip/info-circle-tooltip
    [:div.grid.gap-2
     [:div (get-translation "test.tooltip.traceability.cloning-section"
                            "This section appears when the current test was cloned from another.
                            If changes are made to the original test, you’ll have the option to sync those updates here")]]]])

(defn requirement-children-section-tooltip
  []
  [:span.traceability-section-tooltip
   [common-tooltip/info-circle-tooltip
    [:div.grid.gap-2
     [:div (get-translation "requirement.traceability.tooltip.children-section"
                            "This section displays Requirement Children. Requirements that have defined this requirement as their parent")]]]])

(defn- entities-dialog [{:keys [link-entities-props] :as form-props}]
  (let [container-ref (atom nil)]
    (fn [_]
      [:div
       {:ref #(reset! container-ref %)}
       [add-entities/add-entities-dialog
        container-ref
        (merge link-entities-props
               (select-keys form-props [:get-field-props])
               {:table-id (:dialog-table-id form-props)})]])))

(defn- pagination-view [current-page total-count per-page state]
  [:div.traceability-section-pagination
   [pagination/pagination-view
    {:current-page current-page
     :total-count  total-count
     :per-page     per-page
     :max-buttons  0
     :on-change    (fn [page]
                     (swap! state assoc :current-page page))}]])

(defn- parse-added-entities [form-id field]
  (let [field-input	@(re-frame/subscribe [::subs/get-field-in-form-state2 form-id field])
        value (:value field-input)]
    (when-not (empty? value)
      (->> (str/split value #",")
           (map str/trim)
           (remove str/blank?)
           (vec)))))

(defn get-tooltip-for-add-linked-entity [edit-permissions? linked-entity-limit]
  (cond
    (not edit-permissions?)
    (get-translation "entity.traceability.insuficient_permissions"
                     "You don't have permission to perform this action")
    :else (format-translation (get-translation "entity.traceability.linked_entity_limit"
                                               "Note: The maximum number of linked entities allowed is %{limit}.")
                              {:limit linked-entity-limit})))

(defn- add-traceability-entity-by-id-button [entity-type edit-permissions? total-count linked-entity-limit & [extra-class]]
  (fn []
    (let [field :add-traceability-entity-by-id
          field-props (atom {:type       :text
                             :label      (get-translation "generic.add.by-id" "Add by ID")
                             :title?     true
                             :placeholder  (get-translation "generic.add.by-id" "Add by ID")
                             :field      field
                             :field-id   field})
          form-id (keyword (str (name entity-type) "-" "traceability-section"))
          form-props {:get-field-props (reagent/partial identity field-props)
                      :set-field-state (partial-dispatch-sync [::forms3/set-field-state form-id])
                      :get-field-state (partial-subscribe [::forms3/field-state form-id])
                      :get-form-state (partial-subscribe [::forms3/form-state form-id])
                      :set-form-state (partial-dispatch [::forms3/set-form-state form-id])}
          entity-ids-to-add (parse-added-entities form-id field)
          class (str "traceabilty-section-add-entity-by-id"
                     (when extra-class (str " " extra-class)))
          add-button [buttons/button
                      {:tertiary? true
                       :disabled? (or (empty? entity-ids-to-add)
                                      (>= total-count linked-entity-limit)
                                      (not edit-permissions?))
                       :on-click (fn []
                                   (when-not (empty? entity-ids-to-add)
                                     (re-frame/dispatch [::link-events/add-entities-by-id entity-type entity-ids-to-add form-id field])))
                       :text (get-translation "generic.button.add" "Add")}]]
      [:div {:class class}
       [fields3/build-field
        {:field-name field :edit-permissions? edit-permissions?}
        form-props]
       (if (= entity-type :testset)
         add-button
         [tooltip/mux-tooltip
          {}
          (get-tooltip-for-add-linked-entity edit-permissions? linked-entity-limit)
          (fn [tooltip-props]
            [:span
             tooltip-props
             add-button])])])))

(defn- add-traceability-entity-modal-button [type metadata-key form-props total-count linked-entity-limit]
  [:<> [tooltip/mux-tooltip
        {}
        (get-tooltip-for-add-linked-entity (:edit-permissions? form-props) linked-entity-limit)
        (fn [tooltip-props]
          [:span
           tooltip-props
           (if (= type :tests)
             (if (= (:entity-type form-props) :requirement)
               [new-test-dropdown form-props (or (not (:edit-permissions? form-props)) (>= total-count linked-entity-limit))]
               ;; not sure about button below can not find it on UI, maybe legacy button
               [buttons/button
                {:icon [icons/mux-plus-circle]
                 :text (get-translation "test.new" "New Test")
                 :on-click (let [add-new-test-uri (broutes/get-url-view "qtest_designs#new"
                                                                        {}
                                                                        {"requirement_id" (:entity-id form-props)})]
                             (fn [e]
                               (mixpanel/track "Requirement - Create new Test")
                               (dom/navigate! add-new-test-uri)))}])
             [buttons/button
              {:tertiary? true
               :disabled? (not (:edit-permissions? form-props))
               :class "entity-modal-button-disabled"
               :on-click (fn [_]
                           (mixpanel/track "Form Actions"
                                           {"Entity" (mixpanel/entity-type->mixpanel (:entity-type form-props))
                                            "Action" "Add Entity to traceability"})
                           ((:toggle-link-entities-modal! form-props)))
               :text (get-translation (str (name metadata-key) ".show.plural") (str "Search" " " (name type)))}])])]])

(defn scope-selection-section []
  (let [show-confirmation-modal? (reagent/atom false)
        show-define-linkage-modal? (reagent/atom false)]
    (fn [form-props total-count]
      (let [state-key :link-testsets-state
            can-change-scope? (:edit-permissions? form-props)
            {:keys [base-entity entity-id]} form-props
            testing-scope (:testing_scope base-entity)
            active-scope (reagent/atom (grid-session-storage/load-traceability-scope entity-id))
            testset-linked? (= testing-scope "TESTSETS")
            testset-scope? (or (= :testset @active-scope) testset-linked?)
            traceability @(re-frame/subscribe [::traceability])
            has-linked-testsets? (seq (:testsets traceability))
            has-linked-tests? (seq (:tests traceability))
            hide-define-linkage-message? (grid-storage/load-hide-define-linkage-message)]

        [:div.testing-scope-row
         [:span.testing-status
          [:span (get-translation "requirement.coverage.linkage_type" "Linkage Type")]

          [:div.connected-buttons.scope-buttons.hide-text
           [buttons/button
            {:text (:LAST_RUN (testing-coverage/testing-scope-labels))
             :class (when (not testset-scope?) "selected")
             :size "large"
             :primary? (not testset-scope?)
             :disabled? (not can-change-scope?)
             :on-click (fn []
                         (if (and testset-scope? has-linked-testsets?)
                           (reset! show-confirmation-modal? true)
                           (scope-utils/switch-to-tests state-key active-scope entity-id)))
             :icon [icons/mux-test-library]}]
           [buttons/button
            {:text (:TESTSETS (testing-coverage/testing-scope-labels))
             :class (when testset-scope? "selected")
             :size "large"
             :primary? testset-scope?
             :disabled? (not can-change-scope?)
             :on-click (fn []
                         (cond
                           ;; Has linked tests -> show confirmation modal
                           (and (not testset-scope?) has-linked-tests?)
                           (reset! show-confirmation-modal? true)

                           ;; No linked tests and user hasn't hidden the message -> show define linkage modal
                           (and (not testset-scope?) (not has-linked-tests?) (not hide-define-linkage-message?))
                           (reset! show-define-linkage-modal? true)

                           ;; Default case -> just switch
                           :else
                           (scope-utils/switch-to-testsets state-key active-scope entity-id)))
             :icon [icons/mux-testsets-runs]}]]]

         [:span.tab-delimiter]

         [:span.testing-status
          [:span (get-translation "requirement.coverage.link_items" "Link Items")]]

         [:div.traceabilty-section-add-entity
          (if testset-scope?
            ^{:key "traceability-testset"}
            [add-traceability-entity-by-id-button :testset can-change-scope? total-count LINKED_TESTSETS_FOR_REQUIREMENT_LIMIT "new-scope-compact"]

            ^{:key "traceability-test"}
            [add-traceability-entity-by-id-button :test can-change-scope? total-count LINKED_TESTS_FOR_REQUIREMENT_LIMIT "new-scope-compact"])

          [buttons/button
           {:text (get-translation "generic.button.show-list" "Show List")
            :tertiary? true
            :disabled? (not can-change-scope?)
            :on-click (fn []
                        (mixpanel/track "Form Actions"
                                        {"Entity" (mixpanel/entity-type->mixpanel (:entity-type form-props))
                                         "Action" "Add Entity to traceability"})
                        (if testset-scope?
                          (re-frame/dispatch [::requirements-events/open-link-testset-modal state-key])
                          ((:toggle-link-entities-modal! form-props))))
            :icon [icons/mux-ordered-list]
            :class "hide-text"}]
          (when (not testset-scope?)
            [new-test-dropdown form-props (or (not (:edit-permissions? form-props)) (>= total-count LINKED_TESTS_FOR_REQUIREMENT_LIMIT))])]

         [:span.tab-delimiter]

         [:span.testing-status
          [:span (get-translation "testset.section.status" "Status") ":"]
          (:requirement_status base-entity)]
         [testing-coverage/requirement-status-bar (:grouped_testing_statuses base-entity)]

         [entities-dialog (merge form-props
                                 {:link-entities-props (merge (grid-options {:entity-id entity-id
                                                                             :entity-name (:name (:base-entity form-props))
                                                                             :state-key       state-key
                                                                             :table-id-suffix "link-testsets-grid"
                                                                             :current-entity :requirement
                                                                             :linked-entity-type :testset
                                                                             :linked-entities-key-plural :testsets}
                                                                            (fn [row]
                                                                              (let [traceability @(re-frame/subscribe [::traceability])
                                                                                    linked-testsets (:testsets traceability)
                                                                                    linked-ids (set (map #(:id %) linked-testsets))
                                                                                    linked-entity-limit (get-linked-entity-limit :requirement :testset)]
                                                                                (or (contains? linked-ids (:id row))
                                                                                    (>= (count linked-testsets) linked-entity-limit)))))
                                                              {:title (get-translation "testset.select.plural" "Select Test Sets")}
                                                              (link-entities-dialog-options {:state-key state-key
                                                                                             :link-event ::link-events/link-entities
                                                                                             :current-entity :requirement
                                                                                             :grid-entity :testset}))})]
         [scope-utils/confirm-scope-change-modal testset-scope? show-confirmation-modal? state-key active-scope entity-id]
         [scope-utils/define-linkage-modal show-define-linkage-modal? state-key active-scope entity-id]]))))


(defn- traceability-section-toolbar [type metadata-key form-props grid-props]
  (fn []
    [:div.traceabilty-section-toolbar
     (let [edit-permissions? (:edit-permissions? form-props)
           test-page-and-issue-table? (and (= (:entity-type form-props) :test) (= :issues type))
           instance-and-issue-table? (and (= (:entity-type form-props) :instance) (= :issues type))
           requirement-page-and-test-table? (and (= (:entity-type form-props) :requirement) (= :tests type)) 
           show-toolbar (and (contains? #{:issues :requirements :tests} type)
                             (not test-page-and-issue-table?)
                             (not instance-and-issue-table?)
                             (not requirement-page-and-test-table?))
           total-count (:total-count grid-props)
           linked-entity-limit (get-linked-entity-limit (:entity-type form-props) metadata-key)]
       (when show-toolbar [:div.traceabilty-section-add-entity
                           [add-traceability-entity-by-id-button metadata-key edit-permissions? total-count linked-entity-limit]
                           [:span.tab-delimiter]
                           [add-traceability-entity-modal-button type metadata-key form-props total-count linked-entity-limit]]))
     
     ;; Add sync changes functionality when type is :ancestor_info
     (when (= type :ancestor_info)
       (let [traceability-data (:data grid-props)
             project-id @(re-frame/subscribe [::subs/current-project-id])
             item (first traceability-data)
             {:keys [parent_diff? has_permissions?]} item
             {:keys [disabled? disabled-tooltip]}
             (compute-disabled-state {:has_permissions? (and has_permissions?
                                                             (:edit-permissions? form-props))
                                      :parent_diff? parent_diff?})
             url-name "qtest_designs#update_from_parent_data"
             update-url (broutes/get-url-view url-name {:id (:entity-id form-props)
                                                        :p_id project-id})]
         [:div
          [:span.tab-delimiter]
          [tooltip/mux-tooltip
           {}
           disabled-tooltip
           (fn [props]
             [:span
              (if disabled-tooltip props {})
              [buttons/button
               {:tertiary?  true
                :disabled?  disabled?
                :on-click   (fn [_]
                              (when (js/confirm
                                     (get-translation "test.confirm.ancestor-sync"
                                                      "Update this test?\nThe data in the test will be overridden"))
                                (re-frame/dispatch [::tests-events/update-from-parent-data update-url])))
                :icon       [icons/sync-changes]
                :text       (get-translation "test.traceability.sync-changes" "Sync Changes")}]])]]))
     
     [grid2/default-grid-more-button grid-props]]))


(defn- collapsed-key [table-id]
  (when table-id
    (str table-id "-collapsed")))

(defn save-collapsed
  [table-id collapsed?]
  (when-let [key (collapsed-key table-id)]
    (dom/set-session-item key (str collapsed?))))

(defn load-collapsed
  [table-id]
  (when-let [key (collapsed-key table-id)]
    (try
      (cljs.reader/read-string (dom/get-session-item key))
      (catch js/Error e (js/console.warn e)))))

(defn traceability-section
  [form-props _type _ _ _]
  (let [load-collapsed (:load-collapsed form-props)
        state (-> (reagent/atom {:collapsed?   (when load-collapsed (load-collapsed))
                                 :current-page 1
                                 :per-page 10}))]
    (fn [form-props type metadata-key traceability-data grid-props]
      (let [collapsed? (:collapsed? @state)
            save-collapsed (:save-collapsed form-props)
            have-items? (boolean (seq traceability-data))
            total-count (or (:testset-count form-props) (count traceability-data))
            show-scope-selection-section? (and (or (= type :tests)
                                                   (= type :testsets))
                                               (= (:entity-type form-props) :requirement)
                                               (not collapsed?))
            testsets-in-requirement? (and (= type :testsets)
                                           (= (:entity-type form-props) :requirement))
            current-project-id (when testsets-in-requirement?
                                @(re-frame/subscribe [::subs/current-project-id]))
            table-id (when testsets-in-requirement?
                      (str current-project-id "-" (name (:entity-type form-props)) "-traceability-" (name type)))
            grid-props (merge
                        grid-props
                        {:data traceability-data
                         :grid-state state
                         :total-count total-count}
                        (when testsets-in-requirement?
                          {:show-pagination? false
                           :per-page 100
                           :testsets-in-requirement? true
                           :autofilters-save (fn [filters]
                                              (re-frame/dispatch [::testing-coverage/set-testset-instance-filters table-id filters]))
                           :autofilters-load (fn [] @(re-frame/subscribe [::testing-coverage/testset-instance-filters table-id]))})

                        {:grid-toolbar (fn [grid-props] [traceability-section-toolbar type metadata-key form-props grid-props])})
            linked-label (get-in entities-metadata [metadata-key :linked-label])]

        [:<>
         [:div.section-header-row
          [:div.traceability-collapse-control
           {:on-click (fn [_e]
                        (swap! state update :collapsed? not)
                        (when save-collapsed (save-collapsed (not collapsed?))))
            :class    (dom/classes-pairs-v
                       :clickable have-items?)}
           [:span
            (if collapsed?
              [icons/mux-chevron-right]
              [icons/mux-chevron-up2])]
           [:span
            (section-title metadata-key type total-count form-props)]

           (when (= type :ancestor_info)
             [test-cloning-section-tooltip])]

          (when (= type :called_by_ctts)
            (called-by-tests-section-tooltip))

          (when (= type :requirement_children)
            (requirement-children-section-tooltip))

          [:div.header-controls
           (when (and (contains? #{:issues :requirements :tests} type)
                      (not (and (= (:entity-type form-props) :test) (= :issues type)))
                      (:edit-permissions? form-props))
             [:div.traceability-section-tests [entities-dialog form-props type]])]]

         (when show-scope-selection-section?
           [scope-selection-section form-props total-count])

         (when (not collapsed?) [:div.section-grid [grid2/grid grid-props]])]))))

(defn- traceability-table-id
  [entity-type linked-entity-type]
  (let [entity-str (name linked-entity-type)
        project-id (:id @(re-frame/subscribe [::subs/current-project]))]
    (str project-id "-" entity-str "-link-" (name entity-type) "-grid")))

(defn- traceability-item-delete-button [{:keys [entity-type new?]} item]
  (let [current-entity-id @(re-frame/subscribe [::subs/current-entity-id entity-type])]
    [buttons/button {:on-click (if new?
                                 #(re-frame/dispatch [::link-events/stage-unlink-entity item])
                                 #(re-frame/dispatch [::link-events/unlink-entity entity-type current-entity-id item]))
                     :icon [icons/mux-unlink]
                     :class ["delete-button"]}]))

(defn- traceability-issue-grid-retest-button [{:keys [run-id test-id testset-id]}]
  (let [has-edit-permissions (permissions/has-permission? "runs")
        current-entity-id @(re-frame/subscribe [::subs/current-entity-id :issue])]
    [tooltip/mux-tooltip {}
     (get-translation "issue.tooltip.retest"
                      "This action will create a new run based on the previous one.
            					If there have been significant changes made to the test since that run,
            					please initiate the new run directly from the updated test.")
     (fn [props]
       [:div.retest-container props
        [:button.retest-btn
         {:class (str "retest-btn" (when (not has-edit-permissions) " disabled"))
          :disabled (not has-edit-permissions)
          :on-click (fn [e]
                      (when-not (.-disabled (.-currentTarget e))
                        (set! (.-disabled (.-currentTarget e)) true)
                        (mixpanel/track "Retest from issue" {"Run ID" run-id "Issue ID" current-entity-id})
                        (let [retest-uri (broutes/get-url-view "qtest_runs#retest_run" {:id run-id})
                              params  [run-id test-id testset-id current-entity-id]]
                          (batch-navigate! retest-uri params))))}
         [icons/mux-retest-icon]]])]))

(defn- traceability-issue-grid-run-date [{:keys [run-id date run-type testset-id]}]
  (fn [_props]
    [:a {:target "blank"
         :class "m-pseudolink"
         :href (if (= run-type "etrun")
                 (broutes/get-url-view "et#edit" {:s_id testset-id :id run-id})
                 (broutes/get-url-view "qtest_runs#edit" {:id run-id}))}
     (fu/formatted-date-time date)]))

(defn- get-issue-grid-runs-data [linked-entities]
  (mapv
   (fn [linked-entity]
     (let [{run-id :id run-date :run_date run-status :status run-type :type
            instance :instance
            {system-test-id :id display-test-id :display_id test-name :name project_id :project_id} :test} (-> linked-entity :run)
           {system-testset-id :testset_id display-testset-id :display_id testset-name :name} instance]
       {:re-test {:run-id run-id
                  :test-id system-test-id
                  :testset-id system-testset-id}
        :run-date {:run-id run-id
                   :date run-date
                   :run-type run-type
                   :testset-id system-testset-id}
        :test-name {:title (str "Test #" display-test-id ": " test-name)
                    :url (str "/p/" project_id "/tests/" system-test-id "/edit")}
        :execution-locked? (:execution_locked instance)
        :test-set-name {:title (str "Test Set #" display-testset-id ": " testset-name)
                        :url (str "/p/" project_id "/sets/" system-testset-id "/edit")}
        :run_status run-status
        :run-delete {:item linked-entity}}))
   linked-entities))

(defn linked-runs-section [form-props linked-entity-type linked-entities-key-plural linked-entities]
  (let [issue-columns @(re-frame/subscribe [::grid.subs/columns [:testset :issues-linked-runs]])
        fields @(re-frame/subscribe [::subs/fields])
        sorted-issue-data (vec (sort-by :run-date > (get-issue-grid-runs-data linked-entities)))
        show-delete-column? (:edit-permissions? form-props)
        current-project-id @(re-frame/subscribe [::subs/current-project-id])
        table-id (str current-project-id "-" (name (:entity-type form-props)) "-traceability-" (name linked-entities-key-plural))
        grid-props (merge  {:fields fields
                            :pre-columns [{:type :custom, :field :re-test, :default-width 35, :header (get-translation "issue.button.retest" "Retest"),
                                           :cell-fn (fn [_columns row]
                                                      (if (:execution-locked? row)
                                                        [locked-execution-icon]
                                                        [traceability-issue-grid-retest-button (-> row :re-test)]))}
                                          {:type :custom, :field :run-date, :default-width 75, :header (get-translation "generic.label.run-date" "Run Date"),
                                           :cell-fn (fn [_columns row] [traceability-issue-grid-run-date (-> row :run-date)])}]
                            :columns  issue-columns
                            :data sorted-issue-data
                            :resizable? true
                            :per-page-save (reagent/partial grid-storage/save-per-page table-id)
                            :per-page-load (reagent/partial grid-storage/load-per-page table-id)
                            :autofilters-save      (reagent/partial grid-session-storage/save-autofilters table-id)
                            :autofilters-load      (reagent/partial grid-session-storage/load-autofilters table-id)
                            :sort-order-save       (reagent/partial grid-session-storage/save-sort-order table-id)
                            :sort-order-load       (reagent/partial grid-session-storage/load-sort-order table-id)
                            :columns-widths-save   (reagent/partial grid-storage/save-column-sizes table-id)
                            :columns-widths-load   (reagent/partial grid-storage/load-column-sizes table-id)
                            :full-data? true
                            :class "traceability-tab-grid"
                            :empty-table-message [:div.empty-section-grid [:span (get-translation "entity.traceability.no_linked" "No Items Linked")]]
                            :options {:selectable? true}}
                           (when show-delete-column?
                             {:post-columns [{:type :custom, :field :run-delete, :systemcol? true, :default-width 35,
                                              :header (get-translation "entity.traceability.unlink" "Unlink")
                                              :cell-fn (fn [_columns row] [traceability-item-delete-button form-props (-> row :run-delete :item)])}]}))]
    [traceability-section (merge form-props {:save-collapsed (reagent/partial save-collapsed table-id)
                                             :load-collapsed (reagent/partial load-collapsed table-id)})
     linked-entity-type linked-entities-key-plural sorted-issue-data grid-props]))

(defn- linked-items-section [{:keys [entity-type new?] :as form-props} linked-entity-type linked-entities-key-plural linked-entities grid-props]
  (let [table-id (traceability-table-id entity-type linked-entity-type)
        state-key (keyword (str "link-" (name linked-entities-key-plural) "-state"))
        disabled-row? (fn [row]
                        (let [linked-entities (get @(re-frame/subscribe [::traceability]) linked-entities-key-plural)
                              linked-ids (set (map #(:id %) linked-entities))
                              current-entity-id @(re-frame/subscribe [::subs/current-entity-id entity-type])
                              has-testset-scope? (and (= entity-type :test)
                                                      (= linked-entity-type :requirement)
                                                      (= (:testing_scope row) "TESTSETS"))
                              linked-entity-limit (get-linked-entity-limit entity-type linked-entity-type)]
                          (or (contains? linked-ids (:id row))
                              (and (= entity-type linked-entity-type)
                                   (= (:id row) current-entity-id))
                              (>= (count linked-entities) linked-entity-limit)
                              has-testset-scope?)))
        link-entities-props
        (merge (grid-options {:entity-id (:entity-id form-props)
                              :entity-name (:name (:base-entity form-props))
                              :state-key       state-key
                              :table-id-suffix (str "link-" (name linked-entities-key-plural) "-grid")
                              :current-entity entity-type
                              :linked-entity-type linked-entity-type
                              :linked-entities-key-plural linked-entities-key-plural} disabled-row?)
               (link-entities-dialog-options {:state-key state-key
                                              :link-event (if new?
                                                            ::link-events/stage-link-entities
                                                            ::link-events/link-entities)
                                              :current-entity entity-type
                                              :grid-entity linked-entity-type}))]
    [traceability-section (merge form-props
                                 {:dialog-table-id             table-id
                                  :on-query-changed            (partial-dispatch [::common-events/fetch-entity-list])
                                  :save-collapsed (reagent/partial save-collapsed table-id)
                                  :load-collapsed (reagent/partial load-collapsed table-id)	
                                  :toggle-link-entities-modal! (fn [_e]
                                                                 (re-frame/dispatch [::common-events/toggle-link-entities-modal
                                                                                     linked-entity-type
                                                                                     state-key
                                                                                     ::common-events/fetch-entity-list
                                                                                     (reagent/partial grid-storage/load-per-page linked-entity-type)])
                                                                 (mixpanel/track (str (name entity-type) " - Link " (name linked-entity-type))))
                                  :link-entities-props         link-entities-props})
     linked-entities-key-plural
     linked-entity-type
     linked-entities
     grid-props]))

(defn get-instances-pre-columns
  [extra-pre-columns test-case-versioning-enabled?]
  (concat
   [(when (permissions/has-permission? "runs")
      {:header        (get-translation "testset.button.run" "Run")
       :field         :run
       :default-width 60
       :width         70
       :type          :custom
       :systemcol?    true
       :cell-fn       (fn [column-info row
                           {:keys [local-rows
                                   has-filters?
                                   has-sorting?]
                            :as grid-props}]
                        (let [run-url (broutes/get-url-view "instances#run_now"
                                                            {:set_id (:testset_id row )
                                                             :id     (:id row)}
                                                            {:run_now_origin :instances-grid})
                              run-order (when (or has-filters?
                                                  has-sorting?)
                                          (str/join "," (map :id local-rows)))]

                          (if (:execution_locked row)
                            [locked-execution-icon]
                            [:button.run-button
                             {:on-click (fn [e]
                                          (mixpanel/track "Run")
                                          (if (:able_to_run row)
                                            (dom/form-navigate! run-url
                                                                (when run-order
                                                                  {"run_order" run-order}))
                                            (notifications/notify! (get-translation "testset.notify.cant_run" "Can not run this instance - run order is enforced")
                                                                   {:type       "error"
                                                                    :auto-close true
                                                                    :id         "entity-form-notification"})))}
                             [icons/mux-run-instance]])))})
    {:type :internal-url, :field :instance_link, :systemcol? true, :default-width 250, :autofilter? true, :header (get-translation "entity.traceability.link-to-instance" "Link to Instance")}
    {:type :internal-url, :field :test_set_link, :systemcol? true, :default-width 250, :autofilter? true, :header (get-translation "entity.traceability.link-to-testset" "Link to Test Set")}]
   (when test-case-versioning-enabled?
     [{:type :version_label, :field :version_label, :default-width 150, :autofilter? true, :multiple? true, :show-latest-for-empty? true, :header (get-translation "test.versioning.version-label" "Version Label")}])
   extra-pre-columns))

(def instance-columns 
  {:run_status 0, 
  	:last_run 1, 
 		:tester 2, 
 		:assigned_to 3})

(defn- transform-instance [instance get-translation]
  (let [suite-title (get-in instance [:instance_link :title])]
    (-> instance
        (assoc :instance_link
               {:url (:url instance)
                :title (str (get-translation "entity.traceability.instance-in" "Instance in: ")
                            suite-title)}))))

(defn- expand-testset-with-instances
  "Expands a testset item into a testset row and its paginated instance rows.
   Applies filters to instances before pagination.
   Returns a list containing the testset row and instance rows if expanded,
   or just the testset row if collapsed."
  [testset filters columns]
  (let [collapsed? @(re-frame/subscribe [::testing-coverage/testset-collapsed? (:id testset)])
        instances (:testset-instances testset)
        filtered-instances (if (and filters columns (seq filters))
                            (grid-filters/filter-instances-for-testset
                              instances
                              testset
                              filters
                              columns)
                            instances)
        filtered-count (cond
                         filtered-instances (count filtered-instances)
                         :else (:instances_count testset))
        current-page @(re-frame/subscribe [::testing-coverage/testset-instances-page (:id testset)])
        per-page 5
        start-idx (* (dec current-page) per-page)
        end-idx (+ start-idx per-page)
        page-instances (when (and filtered-instances (pos? (or filtered-count 0)))
                         (subvec (vec filtered-instances)
                                 (min start-idx filtered-count)
                                 (min end-idx filtered-count)))]
    (if (and (not collapsed?)
             page-instances
             (pos? (count page-instances)))
      (cons
       (assoc testset
              :testset-header? true
              :sticky-row? true
              :filtered_instances_count filtered-count)
       (mapv
        (fn [instance]
          (-> (grid-filters/transform-instance-for-testset-grid instance)
              (assoc :instance-row? true
                     :testset_id (:id testset))))
        page-instances))
      [(assoc testset
              :testset-header? true
              :sticky-row? true
              :filtered_instances_count filtered-count)])))

(defn- expand-legacy-instances
  [item]
  (if (not= (count (:instances item)) 0)
    (mapv
     (fn [instance]
       (merge item {:last_run_date (:last_run instance)
                    :run_status (:run_status instance)
                    :test_instance
                    {:url (broutes/get-url-view "instances#edit" {:id (:id instance)})
                     :title (str "Instance ID "
                                 (:display_id instance) " "
                                 (if (empty? (:parameters instance)) "{}" (:parameters instance)))}}))
     (:instances item))
    item))

(defn- expand-traceability-data
  [data testsets-in-requirement? filters columns]
  (if testsets-in-requirement?
    (vec (flatten (mapv #(expand-testset-with-instances % filters columns) data)))
    (vec (flatten (mapv expand-legacy-instances data)))))

(defn traceability-instance-grid
  [form-props linked-entity-type linked-entities-key-plural instances]
  (let [instances-columns @(re-frame/subscribe [::grid.subs/columns [:testset :instances-state]])
        cf-last-run-columns (->> instances-columns
                                 (filter (fn [column] (= "lastrun" (namespace (:field column)))))
                                 (filter (fn [column] (not (= :lastrun/run_run_status (:field column)))))
                                 vec) 
        enabled-fields  (intersection (set (keys @(re-frame/subscribe [::subs/entity-fields linked-entity-type])))
                                      (set (keys instance-columns)))
        instances-columns (->> instances-columns
                                (filter (fn [column] (enabled-fields (:field column))))
                                (mapv (fn [column] (assoc column :systemcol? true)))
                                (sort-by (fn [column] (get instance-columns (:field column)))))
        instances-columns (concat instances-columns cf-last-run-columns)
        fields @(re-frame/subscribe [::subs/fields])
        current-project-id @(re-frame/subscribe [::subs/current-project-id])
        test-case-versioning-enabled? @(re-frame/subscribe [::subs/test-case-versioning-enabled?])
        table-id (str current-project-id "-" (name (:entity-type form-props)) "-traceability-" (name linked-entities-key-plural))
        transformed-instances (mapv #(transform-instance % get-translation) instances)
        grid-props (merge {:fields fields
                          :columns instances-columns
                          :data transformed-instances
                          :pre-columns (get-instances-pre-columns [] test-case-versioning-enabled?)
                          :resizable? true
                          :per-page-save (reagent/partial grid-storage/save-per-page table-id)
                          :per-page-load (reagent/partial grid-storage/load-per-page table-id)
                          :autofilters-save      (reagent/partial grid-session-storage/save-autofilters table-id)
                          :autofilters-load      (reagent/partial grid-session-storage/load-autofilters table-id)
                          :sort-order-save       (reagent/partial grid-session-storage/save-sort-order table-id)
                          :sort-order-load       (reagent/partial grid-session-storage/load-sort-order table-id)
                          :columns-widths-save   (reagent/partial grid-storage/save-column-sizes table-id)
                          :columns-widths-load   (reagent/partial grid-storage/load-column-sizes table-id)
                          :get-field-props #(re-frame/subscribe [::subs/field-props linked-entity-type %])
                          :options {:selectable? true}
                          :class "traceability-tab-grid"
                          :empty-table-message [:div.empty-section-grid [:span (get-translation "entity.traceability.no_linked" "No Items Linked")]]
                          :full-data? true})]

    (fn [form-props metadata-key type]
      [traceability-section (merge form-props {:save-collapsed (reagent/partial save-collapsed table-id)
                                               :load-collapsed (reagent/partial load-collapsed table-id)})
       type metadata-key transformed-instances grid-props])))

(defn- show-delete-column? [entity-type edit-permissions? linked-entities-key-plural]
  (and (not (or (= linked-entities-key-plural :called_by_ctts)
                (= linked-entities-key-plural :ancestor_info)
                (= linked-entities-key-plural :requirement_children)))
       (not (and (= linked-entities-key-plural :issues)
                 (= entity-type :test)))
       (not (and (= linked-entities-key-plural :issues)
                 (= entity-type :instance)))
       edit-permissions?))

(defn filter-out-memo? [field]
      (not (or
             (= :memo (:type field))
             (= :bdd-scenario (:type field))
             (= :preconditions (:name field)))))

(defn- get-linked-entity-columns [linked-entities-key-plural linked-entity-type entity-type testset-linked?]
  (let [test-entity? (= linked-entity-type :test)
        requirement-children-entity? (= linked-entities-key-plural :requirement_children)
        testsets-in-requirement? (and (= linked-entities-key-plural :testsets)
                                      (= entity-type :requirement))
        state-key (cond
                    test-entity? :linked-tests-traceability-grid
                    requirement-children-entity? :linked-requirement-children-traceability-grid
                    :else (keyword (str "linked-" (name linked-entities-key-plural) "-traceability-grid")))
        pre-columns (traceability-linked-entity-columns/get-pre-columns linked-entities-key-plural testset-linked?)
        avalaible-columns @(re-frame/subscribe [::grid.subs/columns [entity-type state-key]])
        filtered-avalaible-columns (filter filter-out-memo? avalaible-columns)
        updated-columns (if (or requirement-children-entity? testsets-in-requirement?)
                          filtered-avalaible-columns
                          (mapv (fn [column] (assoc column :default-show? false)) filtered-avalaible-columns))]
    {:pre-columns pre-columns
     :columns updated-columns}))

(defn traceability-linked-entity-grid
  [form-props linked-entity-type linked-entities-key-plural linked-entity-data]
  (let [fields @(re-frame/subscribe [::subs/fields])
        current-project-id @(re-frame/subscribe [::subs/current-project-id])
        {:keys [entity-type edit-permissions?]} form-props
        show-delete-column? (show-delete-column? entity-type edit-permissions? linked-entities-key-plural)
        requirement-children-section? (= linked-entities-key-plural :requirement_children)
        testsets-in-requirement? (and (= linked-entities-key-plural :testsets)
                                      (= entity-type :requirement))
        table-id (str current-project-id "-" (name (:entity-type form-props)) "-traceability-" (name linked-entities-key-plural))
        grid-props  (merge {:fields fields
                            :data linked-entity-data
                            :per-page-save (reagent/partial grid-storage/save-per-page table-id)
                            :per-page-load (reagent/partial grid-storage/load-per-page table-id)
                            :autofilters-save      (reagent/partial grid-session-storage/save-autofilters table-id)
                            :autofilters-load      (reagent/partial grid-session-storage/load-autofilters table-id)
                            :sort-order-save       (reagent/partial grid-session-storage/save-sort-order table-id)
                            :sort-order-load       (fn [] (or (grid-session-storage/load-sort-order table-id)
                                                              (when-not testsets-in-requirement? [:display_id :desc])))
                            :columns-widths-save   (reagent/partial grid-storage/save-column-sizes table-id)
                            :columns-widths-load   (reagent/partial grid-storage/load-column-sizes table-id)
                            :class "traceability-tab-grid"
                            :empty-table-message [:div.empty-section-grid [:span (get-translation "entity.traceability.no_linked" "No Items Linked")]]
                            :resizable? true
                            :options {:selectable? (not requirement-children-section?)}
                            :full-data? true
                            :get-field-props #(re-frame/subscribe [::subs/field-props linked-entity-type %])}
                           (when show-delete-column?
                             {:post-columns [{:type :custom, :systemcol? true, :field :delete-item, :default-width 35,
                                              :header (get-translation "entity.traceability.unlink" "Unlink")
                                              :cell-fn (fn [_columns row]
                                                         (when-not (:instance-row? row)
                                                           [traceability-item-delete-button form-props row]))}]}))]

    (fn [form-props metadata-key type linked-entity-data]
      (let [url-name (get-in entities-metadata [linked-entity-type :urls :edit])
            testset-linked? (= (get-in form-props [:base-entity :testing_scope]) "TESTSETS")
            testsets-in-requirement? (and (= linked-entities-key-plural :testsets)
                                          (= (:entity-type form-props) :requirement))
            current-filters (when testsets-in-requirement?
                             @(re-frame/subscribe [::testing-coverage/testset-instance-filters table-id]))
            grid-props (merge grid-props
                  (-> (get-linked-entity-columns linked-entities-key-plural
                                                 linked-entity-type
                                                 entity-type
                                                 testset-linked?)
                      (select-keys [:pre-columns :columns])))
            ;;add url for title field
            data (mapv (fn [item] (update item :name (fn [old-name]
                                                       (if (map? old-name)
                                                         old-name
                                                         {:url (broutes/get-url-view url-name {:id (:id item)
                                                                                               :p_id (if (= type :ancestor_info)
                                                                                                       (:parent_p_id item)
                                                                                                       current-project-id)})
                                                          :title old-name})))) linked-entity-data)
            data (if testsets-in-requirement?
                   (vec (sort-by :display_id > data))
                   data)
            data (expand-traceability-data data testsets-in-requirement? current-filters (:columns grid-props))
            form-props (if testsets-in-requirement?
                         (assoc form-props :testset-count (count linked-entity-data))
                         form-props)]
        [linked-items-section form-props metadata-key type data grid-props]))))

(defn show-requirement-children? [requirement-children]
  (let [entity-fields @(re-frame/subscribe [::subs/entity-fields :requirement])]
       (contains? entity-fields :parent_id)))

(defn traceability-tab
  [form-props]
  (let [traceability @(re-frame/subscribe [::traceability])
        {:keys [base-entity]} form-props
        testing-scope (:testing_scope base-entity)
        active-scope (reagent/atom (grid-session-storage/load-traceability-scope (:entity-id form-props)))
        testset-linked? (= testing-scope "TESTSETS")
        testset-scope? (or (= :testset @active-scope) testset-linked?)
        current-project-id @(re-frame/subscribe [::subs/current-project-id])]

    (when (some? traceability)
      [:div.traceability-body-forms3
       (when (or (:runs traceability)
                 (:ets traceability))
         [linked-runs-section form-props :run :testset
          ;; Concat ets and usual tests here
          (apply conj
                 (or (:runs traceability) [])
                 (or (:ets traceability) []))])

       (when (:instances traceability)
         [traceability-instance-grid form-props :instance :instances (:instances traceability)])

       (when testset-scope?
         (when-let [linked-testsets (:testsets traceability)]
           (let [url-name (get-in entities-metadata [:testset :urls :edit])
                 formatted-testsets (mapv (fn [testset-data]
                                            (-> testset-data
                                                (update :name (fn [old-name]
                                                                {:url (broutes/get-url-view url-name {:id (:id testset-data)
                                                                                                      :p_id current-project-id})
                                                                 :title (str (get-entity-name :testset :singular-name) " " old-name)}))
                                                (assoc :testset-header? true
                                                       :sticky-row? true)))
                                          linked-testsets)]
             [traceability-linked-entity-grid form-props :testset :testsets formatted-testsets])))

       (when (not testset-scope?)
         (when-let [linked-tests (:tests traceability)]
           [traceability-linked-entity-grid form-props :test :tests linked-tests]))

       (when-let [linked-issues (:issues traceability)]
         [traceability-linked-entity-grid form-props :issue :issues linked-issues])

       (when-let [linked-requirements (:requirements traceability)]
         [traceability-linked-entity-grid form-props :requirement :requirements linked-requirements])

       (when-let [called_by_ctts (:called_by_ctts traceability)]
         [traceability-linked-entity-grid form-props :test :called_by_ctts called_by_ctts])

       (when-let [ancestor-info (not-empty (:ancestor_info traceability))]
         [traceability-linked-entity-grid form-props :test :ancestor_info ancestor-info])

       (when-let [requirement-children (:requirement_children traceability)]
         (when (show-requirement-children? requirement-children)
           [traceability-linked-entity-grid form-props :requirement :requirement_children requirement-children]))])))
